
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 2c2.448 0 4.828.902 6.683 2.433l2.25-2.25A.625.625 0 0122 2.625v5.417c0 .345-.28.625-.625.625h-5.417a.625.625 0 01-.441-1.067l1.982-1.983c-1.54-1.228-3.49-1.95-5.499-1.95-4.595 0-8.333 3.738-8.333 8.333 0 4.595 3.738 8.333 8.333 8.333a8.276 8.276 0 005.89-2.442.832.832 0 111.18 1.178A9.93 9.93 0 0112 22C6.486 22 2 17.514 2 12S6.486 2 12 2z","fill":"#131313"}})])
          )
        }
      }
    